import type { RecordView } from '@kit/sync/types/record-view';
import { compareTasks } from '@/entities/task/helpers/compare-tasks';
import { isOpenTask } from '@/entities/task/helpers/is-open-task';
import type { Task } from '@/entities/task/schemas/task';
import type { TasksTab } from '../schemas/tasks-tab';

export function tasksForTab(tasks: readonly RecordView<Task>[], tab: TasksTab): RecordView<Task>[] {
  if (tab === 'closed') {
    return tasks
      .filter((view) => !isOpenTask(view.data))
      .sort((a, b) => (b.data.done_on ?? b.updated_at).localeCompare(a.data.done_on ?? a.updated_at));
  }
  const recommendations = tab === 'recommendation';
  return tasks
    .filter((view) => isOpenTask(view.data) && (view.data.kind === 'recommendation') === recommendations)
    .sort((a, b) => compareTasks(a.data, b.data));
}
